var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"vi"},[(!_vm.hasData())?_c('div',[_vm._v(" 게시글 없음")]):_c('div',{staticClass:"v_image"},[_c('img',{staticClass:"v_img",attrs:{"src":_vm.returnImage()}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }